import styled from "@emotion/styled";
import { Link } from "react-aria-components";
import { MDSTextVariant } from "../text/text.types";

export const StyledLink = styled(Link)<{ $variant?: MDSTextVariant }>`
  color: ${({ theme }) => theme.colors.text.link.default};
  text-decoration: underline;
  cursor: pointer;
  text-underline-offset: 3px;

  ${({ theme, $variant }) =>
    $variant
      ? `
    font-size: ${(theme.fontSizes as Record<MDSTextVariant, string>)[$variant]};
    line-height: ${(theme.lineHeights as Record<MDSTextVariant, string>)[$variant]};
    letter-spacing: ${(theme.lineSpacings as Record<MDSTextVariant, string>)[$variant]};
    font-weight: ${
      String($variant).startsWith("header-")
        ? theme.fontWeights.semiBold
        : [MDSTextVariant.TextM, MDSTextVariant.TextSm].includes($variant)
          ? theme.fontWeights.smedium
          : theme.fontWeights.regular
    };
  `
      : ""}

  &:hover:not([data-disabled]) {
    color: ${({ theme }) => theme.colors.text.link.hover};
  }

  &[data-disabled] {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`;
